window.env = "production";
require("./app");
